import { IFilter } from "src/@redux/listRedux";
import commonDataAccess from "../commonDataAccess";

class DocumentDataAccess {
  getFileById = (id: number) => {
    return commonDataAccess.downloadFile("document/get/document", {
      id: id,
    });
  };
  getPublicFileById = (id: number, organizationId: number) => {
    return commonDataAccess.downloadFile("document/get/public/document", {
      organizationId: organizationId,
      id: id,
    });
  };
  deleteById = (id: number) => {
    return commonDataAccess.deleteData("document/delete/document", {
      id: id,
    });
  };

  getDocumentByUserId = (userId: number) => {
    return commonDataAccess.getData("document/get/image", {
      userId: userId,
    });
  };
  getPublicDocumentAsBase64 = (
    organizationId: number,
    entityId: number,
    parameterType: string = "EntityId",
    classType: string = ""
  ) => {
    return commonDataAccess.getData("document/get/public/base64", {
      organizationId: organizationId,
      entityId: entityId,
      parameterType: parameterType,
      classType: classType,
    });
  };

  getDocumentAsBase64 = (
    entityId: number,
    parameterType: string = "EntityId",
    classType: string = ""
  ) => {
    return commonDataAccess.getData("document/get/base64", {
      entityId: entityId,
      parameterType: parameterType,
      classType: classType,
    });
  };
  getDocumentAsBase64WithHandset = (
    entityId: number,
    parameterType: string = "EntityId",
    classType: string = ""
  ) => {
    return commonDataAccess.getData("document/get/base64withHandset", {
      entityId: entityId,
      parameterType: parameterType,
      classType: classType,
    });
  };
  deleteDocumentWithPhysicalFile = (id: number) => {
    return commonDataAccess.deleteData(`document/delete/${id}`);
  };
  getPublicDocumentRef = (
    organizationId: number,
    entityId: number,
    parameterType: string = "EntityId",
    classType: string = ""
  ) => {
    return commonDataAccess.getData("document/get/public/docRef", {
      organizationId: organizationId,
      entityId: entityId,
      parameterType: parameterType,
      classType: classType,
    });
  };
  getDocumentRef = (
    entityId: number,
    parameterType: string = "EntityId",
    classType: string = ""
  ) => {
    return commonDataAccess.getData("document/get/docRef", {
      entityId: entityId,
      parameterType: parameterType,
      classType: classType,
    });
  };
  getAll = (params: {
    classType;
    pageNo;
    pageSize;
    sortData;
    filters: Array<IFilter>;
  }) => {
    let _filters = {};
    params.filters.forEach((item) => {
      if (item.value && item.value.length > 0) {
        _filters["filter." + item.propertyName] = item.value + "-" + item.type;
      }
    });
    let parameters = {
      classType: params.classType,
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      sortPreference: params.sortData,
      ..._filters,
    };

    return commonDataAccess.getData("document/getall", parameters);
  };
}
export default new DocumentDataAccess();
